// const h1 = document.querySelector(".primary-heading");
// console.log(h1);

//addEventListener -> 2 values, 1 event name, 2- function executed after the event

// h1.addEventListener("click", function () {
//   h1.textContent = "My Name";
//   h1.style.backgroundColor = "red";
//   h1.style.padding = "5rem";
// });

var yearEl = document.querySelector(".year");

//new Date() object calls another function that gets the current year
var currentYear = new Date().getFullYear();

yearEl.textContent = currentYear;

//Mobile Nav
// const mobileNav = document.querySelectorAll(".nav-icon");
// const header = document.querySelector(".header");

// mobileNav[0].addEventListener("click", function () {
//   header.classList.add("nav-open");
// });

// mobileNav[1].addEventListener("click", function () {
//   header.classList.remove("nav-open");
// });

const mobileNav = document.querySelector(".btn-mobile-nav");
const header = document.querySelector(".header");

const toggleNav = function () {
  mobileNav.addEventListener("click", function () {
    //if "nav-open" is  there, it will remove it and vice versa..
    header.classList.toggle("nav-open");
  });
};

toggleNav();

/////////////////////////////////////////// Smooth Scrolling

const alllinks = document.querySelectorAll("a:link");

alllinks.forEach(function (link) {
  link.addEventListener("click", function (e) {
    e.preventDefault();
    const href = link.getAttribute("href");

    // Scroll to top
    if (href == "") {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    if (href !== "" && href.startsWith("#")) {
      const secEl = document.querySelector(href);

      if (link.classList.contains("nav-links")) {
        header.classList.remove("nav-open");
      }

      //scrolls to the selected href element
      secEl.scrollIntoView({ behavior: "smooth" });
    }
  });
});
////////////////////////////////////////
//Sticky Nav
const sectionHeroEl = document.querySelector(".section-hero");

var observer = new IntersectionObserver(
  function (entries) {
    const ent = entries[0];
    if (!ent.isIntersecting) {
      document.body.classList.add("sticky");
    } else {
      document.body.classList.remove("sticky");
    }
  },
  {
    // in the viewport
    root: null,

    // as soon as the hero section is out of the viewport
    threshold: 0,

    // Adds the sticky class just 80pixels before the next section
    rootMargin: "-80px",
  }
);

observer.observe(sectionHeroEl);

///////////////////////////////////////////////////////////
// Fixing flexbox gap property missing in some Safari versions
function checkFlexGap() {
  var flex = document.createElement("div");
  flex.style.display = "flex";
  flex.style.flexDirection = "column";
  flex.style.rowGap = "1px";

  flex.appendChild(document.createElement("div"));
  flex.appendChild(document.createElement("div"));

  document.body.appendChild(flex);
  var isSupported = flex.scrollHeight === 1;
  flex.parentNode.removeChild(flex);
  console.log(isSupported);

  if (!isSupported) document.body.classList.add("no-flexbox-gap");
}
checkFlexGap();

// https://unpkg.com/smoothscroll-polyfill@0.4.4/dist/smoothscroll.min.js

/*
.no-flexbox-gap .main-nav-list li:not(:last-child) {
  margin-right: 4.8rem;
}

.no-flexbox-gap .list-item:not(:last-child) {
  margin-bottom: 1.6rem;
}

.no-flexbox-gap .list-icon:not(:last-child) {
  margin-right: 1.6rem;
}

.no-flexbox-gap .delivered-faces {
  margin-right: 1.6rem;
}

.no-flexbox-gap .meal-attribute:not(:last-child) {
  margin-bottom: 2rem;
}

.no-flexbox-gap .meal-icon {
  margin-right: 1.6rem;
}

.no-flexbox-gap .footer-row div:not(:last-child) {
  margin-right: 6.4rem;
}

.no-flexbox-gap .social-links li:not(:last-child) {
  margin-right: 2.4rem;
}

.no-flexbox-gap .footer-nav li:not(:last-child) {
  margin-bottom: 2.4rem;
}

@media (max-width: 75em) {
  .no-flexbox-gap .main-nav-list li:not(:last-child) {
    margin-right: 3.2rem;
  }
}

@media (max-width: 59em) {
  .no-flexbox-gap .main-nav-list li:not(:last-child) {
    margin-right: 0;
    margin-bottom: 4.8rem;
  }
}
*/
